/**
 * System/web-safe fonts that are available in all browsers without a Google
 * Fonts stylesheet. Keys are lowercased for case-insensitive lookup.
 */
export const DEFAULT_FONTS = new Set<string>([
  'arial',
  'arial black',
  'comic sans ms',
  'courier new',
  'georgia',
  'impact',
  'lucida console',
  'lucida sans unicode',
  'palatino linotype',
  'tahoma',
  'times new roman',
  'trebuchet ms',
  'verdana',
]);
